import { AssistantNodeAction } from "../../Models/NodeType";

import VoiceCallAction from "./VoiceCallAction";
import WhatsappMessageAction from "./WhatsappMessageAction";

export default AssistantConfig;

const AssistantConfigActionRegistry = {
  [AssistantNodeAction.VOICE_CALL]: VoiceCallAction,
  [AssistantNodeAction.WHATSAPP_MESSAGE]: WhatsappMessageAction,
};

function AssistantConfig(props) {
  const { node } = props;

  const AssistantAction = AssistantConfigActionRegistry[node.data.action];

  return <AssistantAction {...props} />;
}
